export default "__VITE_ASSET__Bv5q1aU1__"